// extracted by mini-css-extract-plugin
export default {"productCarousal":"DisOurFav_productCarousal__-OvlU","preBtn":"DisOurFav_preBtn__hJzQW","nextBtn":"DisOurFav_nextBtn__fsVI5","myCardCaption":"DisOurFav_myCardCaption__6igGe"};